import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, fromEvent, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResizeService implements OnDestroy {
  private unscriber$: Subject<void> = new Subject<void>();
  public screenHeight$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor() {
    this.init();
  }

  ngOnDestroy(): void {
    this.unscriber$.next();
    this.unscriber$.complete();
  }

  private init(): void {
    this.setScreenHeight(window.innerHeight);
    fromEvent(window, 'resize').pipe(
      debounceTime(100),
      takeUntil(this.unscriber$),
    ).subscribe(event => {
      const tar = event.target as Window;
      console.log('ResizeService::resize tar=', tar);
      this.setScreenHeight(tar.innerHeight);
    });
  }

  private setScreenHeight(height: number): void {
    this.screenHeight$.next(height);
  }
}
